import api from 'api';
import {useDeleteApi} from 'common/hooks/useDeleteApi';
import {usePostApi} from 'common/hooks/usePostApi';
import React from 'react';
import {ILogFilters} from 'types/diplomat/logs/LogFilter';
import {ILogView} from 'types/diplomat/logs/LogView';
import {CloudTransport} from 'types/transport/Transport';

type Props = {
   logNames?: string[];
   transport?: CloudTransport;
   logFilters?: ILogFilters;
};
export const useFetchLogsView = (query: Props) => {
   const {transport, logFilters, logNames = null} = query;
   const {request: deleteLog} = useDeleteApi(transport ? api.remoteAgentLogsView : api.logsView);
   const {request, state, loading, error} = usePostApi<ILogView>(
      transport ? api.remoteAgentLogsView : api.logsView
   );

   const fetch = React.useCallback(() => {
      request(
         JSON.stringify({
            transport,
            logFilters,
            logNames,
         })
      );
   }, [transport, logFilters, logNames, request]);

   // Remove temp file on close
   React.useEffect(() => {
      return () => {
         if (state?.viewId) {
            deleteLog({
               searchParams: {
                  viewId: state?.viewId,
               },
            });
         }
      };
   }, [deleteLog, state]);

   return {
      fetch,
      state,
      loading,
      error,
   };
};
